import { Button, Grid } from "@mui/material";
import React, { useState } from "react";
import ReportDimension from "./Dimensions/ReportDimension";
import ReportValues from "../ReportBuilder/Values/ReportValues";
import SelectedItems from "./SelectedItems";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import reportbuilder from "./ReportBuilder.module.css";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../utils/Loader/Loader";
import {
  setDimensionVal,
  setLogicalFilter,
  setReportVal,
} from "../../reduxStore/reducer";
import { encrypt } from "../../utils/cipher";
import Swal from "sweetalert2";
import SecureLS from "secure-ls";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./style.css";
import { GridContextProvider, swap, move } from "react-grid-dnd";
import { ButtonStyles } from "../DashBoardLayout/styles/ButtonStyles";
const ReportBuilderMainLayout = () => {
  var ls = new SecureLS();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const today = dayjs(new Date());
  const yesterday = dayjs().add(-1, "day");

  const [fromDate, setFromDate] = useState(yesterday);
  const [toDate, setToDate] = useState(today);
  const [isLoading, setIsLoading] = useState();
  const selectedDimensions = useSelector(
    (state) => state.selectedDimensions.dimensionsVal[0].dimensionBottom
  );
  const selectedValues = useSelector(
    (state) => state.selectedDimensions.reportVal[0].reportBottom
  );
  const selectedLogicalFilters = useSelector(
    (state) => state.selectedDimensions.logicalFilter
  );
  const valItems = useSelector((state) => state.selectedDimensions.reportVal);
  const dimensionItems = useSelector(
    (state) => state.selectedDimensions.dimensionsVal
  );

  const token = ls.get("token");

  console.log("Dates", fromDate, toDate);
  const dynamicPayload = {
    reportCategory: "DYNAMIC",
    selectedDimensions,
    selectedValues,
    selectedLogicalFilters,
    reportDetails: {
      fromDate,
      toDate,
    },
    token: token,
  };
  let encryptedPayload = encrypt(dynamicPayload);

  const onResetHandeler = () => {
    dispatch(
      setDimensionVal([
        {
          ["dimensionBottom"]: [],
          ["dimensionTop"]: [
            { id: 1, name: "PFM" },
            { id: 2, name: "POP" },
            { id: 3, name: "Corporate" }, //corrected the sequence
            { id: 4, name: "Age Group" },
            { id: 5, name: "Tier Type" },
            { id: 6, name: "State" },
            { id: 7, name: "Category" },
          ],
        },
      ])
    );
    dispatch(
      setReportVal([
        {
          ["reportBottom"]: [],
          ["reportTop"]: [
            { id: 1, name: "AUM" },
            { id: 2, name: "TierI Total Net Contribution" },
            { id: 3, name: "TierII Total Net Contribution" },
            { id: 4, name: "PRAN Count" },
            { id: 5, name: "Total Contribution" },
            { id: 6, name: "Tier I AUM" },
            { id: 7, name: "Tier II AUM" },
            // { id: 8, name: ""}
          ],
        },
      ])
    );
    dispatch(setLogicalFilter([]));
    setIsLoading(false);
    setFromDate(yesterday);
    setToDate(today);
  };
  const onDownloadHandeler = async () => {
    console.log("selectedPayload", dynamicPayload);
    setIsLoading(true);
    await axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/createReport`, {
        payload: encryptedPayload,
      })
      .then((res) => {
        setIsLoading(false);
        console.log("inside dynamic report");
        if (res.data.url) {
          window.open(
            `${process.env.REACT_APP_BACKEND_URL}/reports/downloadfile?link=${res.data.url}`
          );
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: "File downloaded successfully",
            icon: "success",
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "File couldn't be Downloaded",
            icon: "error",
          });
          setIsLoading(false);
        }
      })
      .catch((err) => {
        ls.clear();
        console.log("err", err);
        Swal.fire({
          title: "Error",
          text: "Session Expired",
          icon: "error",
        });
        navigate("/");
      });
  };
  const onChange = (sourceId, sourceIndex, targetIndex, targetId) => {
    console.log("on chnage", sourceId, sourceIndex, targetIndex, targetId);
    //not getting target???
    if (
      (sourceId == "dimensionTop" && targetId == "dimensionBottom") ||
      (sourceId == "dimensionBottom" && targetId == "dimensionTop")
    ) {
      console.log("hiii from on dim", targetId);
      onDimensionChange(sourceId, sourceIndex, targetIndex, targetId);
    } else if (
      (sourceId == "reportTop" && targetId == "reportBottom") ||
      (sourceId == "reportBottom" && targetId == "reportTop")
    ) {
      onValChange(sourceId, sourceIndex, targetIndex, targetId);
    }
  };
  function onValChange(sourceId, sourceIndex, targetIndex, targetId) {
    console.log("val ids", sourceId, sourceIndex, targetIndex, targetId);
    if (targetId) {
      const result = move(
        valItems[0][sourceId],
        valItems[0][targetId],
        sourceIndex,
        targetIndex
      );
      console.log("res", result);
      dispatch(
        setReportVal([
          {
            ...valItems[0],
            [sourceId]: result[0],
            [targetId]: result[1],
          },
        ])
      );
    } else {
      const result = swap(valItems[0][sourceId], sourceIndex, targetIndex);

      dispatch(
        setReportVal([
          {
            ...valItems[0],
            [sourceId]: result,
          },
        ])
      );
    }
  }
  function onDimensionChange(sourceId, sourceIndex, targetIndex, targetId) {
    console.log("ids", sourceId, sourceIndex, targetIndex, targetId);
    if (targetId) {
      const result = move(
        dimensionItems[0][sourceId],
        dimensionItems[0][targetId],
        sourceIndex,
        targetIndex
      );
      console.log("res", result);
      dispatch(
        setDimensionVal([
          {
            ...dimensionItems[0],
            [sourceId]: result[0],
            [targetId]: result[1],
          },
        ])
      );

      // setdimensionItems({
      //   ...dimensionItems,
      //   [sourceId]: result[0],
      //   [targetId]: result[1],
      // });
    } else {
      const result = swap(
        dimensionItems[0][sourceId],
        sourceIndex,
        targetIndex
      );

      dispatch(
        setDimensionVal([
          {
            ...dimensionItems[0],
            [sourceId]: result,
          },
        ])
      );
      // return setdimensionItems({
      //   ...dimensionItems,
      //   [sourceId]: result
      // });
    }
  }

  return (
    <Grid
      container
      // spacing={2}
      sx={{ margin: "12vh 0vw 0vh 2vw" }}
    >
      <Grid className="mainRB" container xs={12} sx={{ gap: "1vh" }}>
        <Grid
          className="headerRB"
          xs={11}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            height: "8vh",
          }}
        >
          <Grid xs={12} sm={4}>
            <h2 className={reportbuilder.header}>Report Builder</h2>
          </Grid>
          <Grid xs={12} sm={7}>
            <div className="DateContainer">
              {/* <div className="fromDate"> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  label="From Date"
                  defaultValue={fromDate}
                  disableFuture
                  format="DD/MM/YYYY"
                  disableHighlightToday
                  onChange={(date) => {
                    if (date) {
                        console.log(
                          "datedate",
                          date.toISOString().split("T")[0]
                        );
                        let fromDate = date.toISOString().split("T")[0]; // Get YYYY-MM-DD part
                        setFromDate(fromDate);
                        console.log("Report Date---", fromDate);
                    }
                  }}
                  slotProps={{
                    textField: {
                      variant: "standard",
                      size: "smaller",
                      fullWidth: true,
                    },
                  }}
                  sx={{
                    fontSize: "10px",
                  }}
                />
              </LocalizationProvider>
              {/* </div> */}
              {/* <div className="toDate"> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  label="To Date"
                  defaultValue={toDate}
                  disableFuture
                  format="DD/MM/YYYY"
                  onChange={(date) => {
                    if (date) {
                      console.log("datedate", date);
                      let toDate = date.toISOString().split("T")[0]; // Get YYYY-MM-DD part
                      setToDate(toDate);
                      console.log("Report Date---", toDate);
                    }
                  }}
                  slotProps={{
                    textField: {
                      variant: "standard",
                      size: "smaller",
                      fullWidth: true,
                      // fontSize: "40px",
                    },
                  }}
                />
              </LocalizationProvider>
              {/* </div> */}
            </div>
          </Grid>
        </Grid>

        <Grid
          className="bodyRB"
          xs={11}
          sx={{ display: "flex", gap: "2vh", flexDirection: "column" }}
        >
          <GridContextProvider className="GRID" onChange={onChange}>
            <Grid xs={12} className="box1" sx={{ height: "17vh" }}>
              <ReportDimension />
            </Grid>
            <Grid xs={12} className="box2" sx={{ height: "17vh" }}>
              <ReportValues />
            </Grid>
            <Grid xs={12} className="selectItem">
              <SelectedItems />
            </Grid>

            <Grid
              xs={12}
              className="footBtnRB"
              sx={{
                display: "flexbox",
                flexDirection: "row",
                height: "10vh",
                margin: "auto",
              }}
            >
              <Button
                className="btnRBReset"
                sx={ButtonStyles.footerResetBtn}
                onClick={onResetHandeler}
              >
                Reset
              </Button>
              <Button
                className="btnRBDownload"
                sx={ButtonStyles.footerDownloadBtn}
                onClick={onDownloadHandeler}
              >
                {isLoading ? "Downloading..." : "Download"}
                {isLoading && <Loader color="#1D1C3E" />}
              </Button>
            </Grid>
          </GridContextProvider>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ReportBuilderMainLayout;
